// extracted by mini-css-extract-plugin
export default {"container":"blocks_container__3yUHl","block":"blocks_block__2Evmj","image":"blocks_image__NQYKU","title":"blocks_title__3Jnqu","withoutLines":"blocks_withoutLines__sp9xV"};